import React, { useState, useEffect,useCallback,useMemo   } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Box,
  Typography,
  Button
} from '@mui/material';
import { AddCircle as AddCircleIcon, Delete as DeleteIcon } from '@mui/icons-material';
import { API_BASE_URL } from '../api'; // Import API function


function ConfigTable({ tableData, setTableData, errors, touched, tableKey, otherTableData }) {
  const initialSelectOptions = ['String', 'Long','Double','MultipartFile'];
  const specialInstructionOptions = [{},{label:'Use for linking through mobile number', value :'USE_TO_LINK_THROUGH_MOBILE'}];
  const [allSecondOptions, setAllSecondOptions] = useState({
    'String': ['strAttribute1', 'strAttribute2', 'strAttribute3','strAttribute4', 'strAttribute5', 'strAttribute6','strAttribute7', 'strAttribute8', 'strAttribute9','strAttribute10', 'strAttribute11', 'strAttribute12', 'strAttribute13', 'strAttribute14', 'strAttribute15'],
    'Long': ['longWrapperAttribute1', 'longWrapperAttribute2', 'longWrapperAttribute3','longWrapperAttribute4', 'longWrapperAttribute5', 'longWrapperAttribute6','longWrapperAttribute7', 'longWrapperAttribute8', 'longWrapperAttribute9','longWrapperAttribute10','longWrapperAttribute11', 'longWrapperAttribute12', 'longWrapperAttribute13','longWrapperAttribute14', 'longWrapperAttribute15', 'longWrapperAttribute16','longWrapperAttribute17', 'longWrapperAttribute18', 'longWrapperAttribute19', 'longWrapperAttribute20', 'longWrapperAttribute21', 'longWrapperAttribute22', 'longWrapperAttribute23', 'longWrapperAttribute24', 'longWrapperAttribute25', 'longWrapperAttribute26', 'longWrapperAttribute27', 'longWrapperAttribute28', 'longWrapperAttribute29', 'longWrapperAttribute30', 'longWrapperAttribute31', 'longWrapperAttribute32', 'longWrapperAttribute33', 'longWrapperAttribute34', 'longWrapperAttribute35'],
    'Double': ['doubleWrapperAttribute2', 'doubleWrapperAttribute3','doubleWrapperAttribute4', 'doubleWrapperAttribute5', 'doubleWrapperAttribute6','doubleWrapperAttribute7', 'doubleWrapperAttribute8', 'doubleWrapperAttribute9','doubleWrapperAttribute10','doubleWrapperAttribute11', 'doubleWrapperAttribute12', 'doubleWrapperAttribute13','doubleWrapperAttribute14', 'doubleWrapperAttribute15', 'doubleWrapperAttribute16','doubleWrapperAttribute17', 'doubleWrapperAttribute18', 'doubleWrapperAttribute19', 'doubleWrapperAttribute20', 'doubleWrapperAttribute21', 'doubleWrapperAttribute22', 'doubleWrapperAttribute23', 'doubleWrapperAttribute24', 'doubleWrapperAttribute25', 'doubleWrapperAttribute26', 'doubleWrapperAttribute27', 'doubleWrapperAttribute28', 'doubleWrapperAttribute29', 'doubleWrapperAttribute30', 'doubleWrapperAttribute31', 'doubleWrapperAttribute32', 'doubleWrapperAttribute33', 'doubleWrapperAttribute34', 'doubleWrapperAttribute35'],
    'MultipartFile': ['fileAttribute1', 'fileAttribute2', 'fileAttribute3'],
  });

  const handleAddRow = () => {
    setTableData(tableKey, [...tableData, { placeHolderText: '', description: '', dataType: 'String', correspondingTableColumnName: '', file: null,existingFileName:null }]);
  };

  const handleRemoveRow = (index) => {
    const newTableData = [...tableData];
    newTableData.splice(index, 1);
    setTableData(tableKey, newTableData);
  };

  const handleChange = (index, event) => {
    const { name, value } = event.target;
    // const newTableData = [...tableData];
    // newTableData[index][name] = value;
    //setTableData(tableKey, newTableData);
    // Use setTableData (Formik's setFieldValue) with the field path
     setTableData(`${tableKey}[${index}].${name}`, value);
  };

  const handleSelectChange = (index, event) => {
    const { name,value } = event.target;
    // const newTableData = [...tableData];
    // newTableData[index].dataType = value;
    // newTableData[index].correspondingTableColumnName = '';  // Reset second select
    // newTableData[index].file = null;
    // setTableData(tableKey, newTableData);

    // Use setTableData (Formik's setFieldValue) with the field path
        setTableData(`${tableKey}[${index}].${name}`, value);
        // Also reset the second select choice when the first changes
        setTableData(`${tableKey}[${index}].correspondingTableColumnName`, '');
         // And clear the file if "File Upload" is no longer selected
         if (value !== 'MultipartFile') {
             setTableData(`${tableKey}[${index}].file`, null);
         }
  };

  const handleSecondSelectChange = (index, event) => {
    // const { value } = event.target;
    // const newTableData = [...tableData];
    // newTableData[index].correspondingTableColumnName = value;
    // setTableData(tableKey, newTableData);
    const { name, value } = event.target; // name will be "secondSelectChoice"
        // Use setTableData (Formik's setFieldValue) with the field path
        setTableData(`${tableKey}[${index}].${name}`, value);
  };

   const handleSpecialInstructionSelectChange = (index, event) => {
    // const { value } = event.target;
    // const newTableData = [...tableData];
    // newTableData[index].correspondingTableColumnName = value;
    // setTableData(tableKey, newTableData);
    const { name, value } = event.target; // name will be "secondSelectChoice"
        // Use setTableData (Formik's setFieldValue) with the field path
        setTableData(`${tableKey}[${index}].${name}`, value);
  };


  const handleFileChange = (index, event) => {
    
    const file = event.target.files[0];
    //alert('file change called'+file);
    // const newTableData = [...tableData];
    // newTableData[index].file = file;
    // setTableData(tableKey, newTableData);
            setTableData(`${tableKey}[${index}].file`, file);

  };

  // Function to get available options for the second select (excluding already selected)
  const getAvailableSecondOptions = useCallback((index) => {
    const firstChoice = tableData[index].dataType;
    const allOptions = allSecondOptions[firstChoice] || [];

    // Get currently selected options in the current table
    const selectedOptions = tableData.map((row, i) => (i !== index ? row.correspondingTableColumnName : null)).filter(Boolean);

    // Also, get selected options from the other table
    const otherSelectedOptions = otherTableData ? otherTableData.map(row => row.correspondingTableColumnName).filter(Boolean) : [];

    // Combine selected options from both tables
    
    const allSelectedOptions = [...selectedOptions, ...otherSelectedOptions]; 
    //const allSelectedOptions = [...selectedOptions];

    return allOptions.filter(option => !allSelectedOptions.includes(option));
}, [tableData, otherTableData, allSecondOptions]);


  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label="config table">
        <TableHead sx={{ position: 'sticky', top: 0, backgroundColor: 'white' }}>
          <TableRow>
            <TableCell>Place Holder Text</TableCell>
            <TableCell>Select Data Type</TableCell>
            <TableCell>Select corresponding table column name</TableCell>
            <TableCell>File (if selected)</TableCell>
            <TableCell>Special Instruction</TableCell>
            <TableCell>Description</TableCell>
            <TableCell>Actions</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {tableData.map((row, index) => (
            <TableRow key={index}>
              <TableCell>
                <TextField
                  name="placeHolderText"
                  value={row.placeHolderText}
                  onChange={(event) => handleChange(index, event)}
                  error={touched && touched[index] && touched[index].placeHolderText && errors && errors[index] && errors[index].placeHolderText ? true : false}
                  helperText={touched && touched[index] && touched[index].placeHolderText && errors && errors[index] && errors[index].placeHolderText ? errors[index].placeHolderText : null}
                />
              </TableCell>
             
              <TableCell>
                <FormControl fullWidth>
                  <InputLabel id={`select-label-${index}`}>Data Type</InputLabel>
                  <Select
                    labelId={`select-label-${index}`}
                    name="dataType"
                    value={row.dataType}
                    onChange={(event) => handleSelectChange(index, event)}
                  >
                    {initialSelectOptions.map((option) => (
                      <MenuItem key={option} value={option}>{option}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </TableCell>
              <TableCell>
                <FormControl fullWidth>
                  <InputLabel id={`second-select-label-${index}`}>Second Choice</InputLabel>
                  <Select
                    labelId={`second-select-label-${index}`}
                    name="correspondingTableColumnName"
                    value={row.correspondingTableColumnName}
                    onChange={(event) => handleSecondSelectChange(index, event)}
                  >
                    {getAvailableSecondOptions(index).map((option) => (
                      <MenuItem key={option} value={option}>{option}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </TableCell>
              <TableCell>
                {row.dataType === 'MultipartFile' && (
                  <Box mb={2} display="flex" alignItems="center">
                                {row.existingFileName && (
                                  <Box mr={2}>
                                    <Typography variant="body2">
                                      Current File:
                                      <a target="_blank" rel="noreferrer" href={`${API_BASE_URL}/files/${row.clientId}/${row.existingFileName}`} download> {/* Link to download the file */}
                                        {row.existingFileName}
                                      </a>
                                    </Typography>
                                  </Box>
                                )}
                                <input
                                  type="file"
                                  style={{ display: 'none' }}
                                  onChange={(event) => handleFileChange(index, event)}
                                  // id={`file-input-id-${index}`}
                                  // name={`file-input-name-${index}`}
                                  id={`file-id-${index}`}
                                  name='file'
                                />
                                <label htmlFor={`file-id-${index}`}>
                                  <Button variant="outlined" component="span">
                                    {row.file ? row.file.name : 'Replace File'} {/* Text when replacing */}
                                  </Button>
                                </label>
                                {touched && touched[index] && touched[index].file && errors && errors[index] && errors[index].file ? (
                                  <Typography color="error">{errors[index].file}</Typography>
                                  
                                ):null}
                              </Box>
                )}


              </TableCell>
              <TableCell>
                <FormControl fullWidth>
                  <InputLabel id={`select-label-${index}`}>Special Instruction</InputLabel>
                  <Select
                    labelId={`select-label-${index}`}
                    name="specialInstruction"
                    value={row.specialInstruction}
                    onChange={(event) => handleSpecialInstructionSelectChange(index, event)}
                  >
                    {specialInstructionOptions.map((option) => (
                      <MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </TableCell>
              <TableCell>
                <TextField
                  name="description"
                  value={row.description}
                  onChange={(event) => handleChange(index, event)}
                  error={touched && touched[index] && touched[index].description && errors && errors[index] && errors[index].description ? true : false}
                  helperText={touched && touched[index] && touched[index].description && errors && errors[index] && errors[index].description ? errors[index].description : null}
                />
              </TableCell>
              <TableCell>
                <IconButton onClick={() => handleRemoveRow(index)}>
                  <DeleteIcon />
                </IconButton>
              </TableCell>
            </TableRow>
          ))}
          <TableRow>
            <TableCell colSpan={6}>
              <IconButton onClick={handleAddRow}>
                <AddCircleIcon />
              </IconButton>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default ConfigTable;